<template>
  <v-form
    class="bg-light py-md-3 py-1 px-3 rounded mb-1"
    @submit.prevent="submit()"
  >
    <div class="row">
      <div class="col-3">
        <div class="pb-0">
          <v-text-field
            v-model="discount.cutoff_count"
            label="Quantity more than*"
            :error-messages="
              v$.discount.cutoff_count.$errors.map((e) => e.$message)
            "
            type="number"
            @blur="v$.discount.cutoff_count.$touch()"
          />
        </div>
      </div>
      <div class="col-2">
        <div class="pb-0">
          <v-text-field
            v-model="discount.amount"
            label="Discount Amount*"
            type="number"
            step="0.01"
            :error-messages="v$.discount.amount.$errors.map((e) => e.$message)"
            @blur="v$.discount.amount.$touch()"
          />
        </div>
      </div>
      <div class="col-4 pt-2">
        <strong>Price after Discount:</strong>
        {{
          discount.amount
            ? toCurrency(totalIncudedProductsValue - discount.amount)
            : toCurrency(totalIncudedProductsValue)
        }}
      </div>

      <div class="col-2 d-flex">
        <button
          v-if="discount.id"
          type="button"
          class="btn btn-default btn-form-group p-2 formButton"
          :disabled="saveInProgress"
          @click="save"
        >
          Save
          <span
            v-show="saveInProgress"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
        </button>
        <button
          v-if="discount.id"
          type="button"
          class="btn btn-default btn-form-group p-2 formButton"
          :disabled="deleteInProgress"
          @click="remove"
        >
          Delete
          <span
            v-show="deleteInProgress"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
        </button>

        <button
          v-if="!discount.id"
          type="button"
          class="btn btn-default btn-form-group p-2 formButton"
          :disabled="addInProgress"
          @click="add"
        >
          Add
          <span
            v-show="addInProgress"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
        </button>
      </div>
    </div>
  </v-form>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import axios from 'axios';

import { appValidator } from '../../common/core/utils/validator';
import { toCurrency } from '../../helpers/currency';

export default {
  props: ['value', 'index', 'package_id', 'totalIncudedProductsValue'],
  setup() {
    return { v$: useVuelidate(), toCurrency };
  },
  data() {
    return {
      discount: { ...this.value },
      saveInProgress: false,
      deleteInProgress: false,
      addInProgress: false,
    };
  },

  validations() {
    return {
      discount: {
        cutoff_count: {
          required: appValidator.required,
        },
        amount: {
          required: appValidator.required,
        },
      },
    };
  },

  methods: {
    validate() {
      let error = false;
      if (this.v$.$invalid) {
        this.v$.$touch();
        error = true;
      }

      return !error;
    },

    async save() {
      if (!this.validate()) {
        return;
      }

      this.saveInProgress = true;
      const response = await axios.put(
        `/api/package-discounts/${this.discount.id}`,
        this.discount,
      );
      this.saveInProgress = false;

      this.$emit('save-discount', this.index, this.discount);
    },

    async add() {
      if (!this.validate()) {
        return;
      }
      this.discount.package_id = this.package_id;
      this.addInProgress = true;
      const response = await axios.post(
        '/api/package-discounts',
        this.discount,
      );
      this.addInProgress = false;

      this.discount.id = response.data.id;

      this.$emit('add-discount', this.discount);

      this.discount = {};
      this.v$.discount.$reset();
    },

    async remove() {
      if (confirm('Do you really want to delete?')) {
        this.deleteInProgress = true;
        const response = await axios.delete(
          `/api/package-discounts/${this.discount.id}`,
          this.discount,
        );
        this.deleteInProgress = false;

        this.$emit('remove-discount', this.index);
      }
    },
  },
};
</script>
<style scoped>
.formButton {
  height: fit-content;
}
</style>
